import { useState, useCallback } from 'react';

export interface PropertyFormData {
  // General Info
  ownerCivility: string;
  ownerLastName: string;
  ownerFirstName: string;
  ownerAddress: string;
  ownerWilaya: string;
  ownerCity: string;
  ownerPhone: string;
  ownerEmail: string;
  propertyType: string;
  propertyAddress: string;
  propertyWilaya: string;
  propertyCity: string;
  reference: string;
  sellerPrice: string;
  agencyCommission: string;
  salePrice: string;
  agent: string;

  // Property Details
  apartmentType?: string;
  condition?: string;
  constructionYear?: string;
  livingArea?: string;
  usableArea?: string;
  floor?: string;
  hasElevator?: boolean;
  view?: string;
  roomCount?: string;
  bedroomCount?: string;
  kitchenType?: string;
  bathroomCount?: string;
  hasParking?: boolean;
  hasBalcony?: boolean;
  hasCellar?: boolean;
  hasAirConditioning?: boolean;
  is_concierge?: boolean;
  transactionType?: string;
}

const initialFormData: PropertyFormData = {
  ownerCivility: '',
  ownerLastName: '',
  ownerFirstName: '',
  ownerAddress: '',
  ownerWilaya: '',
  ownerCity: '',
  ownerPhone: '',
  ownerEmail: '',
  propertyType: '',
  propertyAddress: '',
  propertyWilaya: '',
  propertyCity: '',
  reference: '',
  sellerPrice: '',
  agencyCommission: '',
  salePrice: '0',
  agent: '',

  // ✅ AJOUTE TOUS LES CHAMPS OPTIONNELS
  apartmentType: '',
  condition: '',
  constructionYear: '',
  livingArea: '',
  usableArea: '',
  floor: '',
  hasElevator: false,
  view: '',
  roomCount: '',
  bedroomCount: '',
  kitchenType: '',
  bathroomCount: '',
  hasParking: false,
  hasBalcony: false,
  hasCellar: false,
  hasAirConditioning: false,
  is_concierge: false,
  transactionType: '',
};

export const usePropertyForm = () => {
  const [formData, setFormData] = useState<PropertyFormData>(initialFormData);

  const handleInputChange = useCallback((
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData(prev => {
      const newData = {
        ...prev,
        [name]: type === 'checkbox'
          ? (e.target as HTMLInputElement).checked
          : value
      };

      // Calculate sale price when seller price or commission changes
      if (name === 'sellerPrice' || name === 'agencyCommission') {
        const sellerPrice = parseFloat(newData.sellerPrice) || 0;
        const commission = parseFloat(newData.agencyCommission) || 0;
        newData.salePrice = (sellerPrice + commission).toString();
      }

      return newData;
    });  // ✅ ACCOLADE FERMANTE AJOUTÉE ICI
  }, []);

  const updateFormData = useCallback((updates: Partial<PropertyFormData>) => {
    setFormData(prev => ({ ...prev, ...updates }));
  }, []);

  const handleCopyAddress = useCallback(() => {
    setFormData(prev => ({
      ...prev,
      propertyAddress: prev.ownerAddress,
      propertyWilaya: prev.ownerWilaya,
      propertyCity: prev.ownerCity
    }));
  }, []);

  return {
    formData,
    handleInputChange,
    updateFormData,
    handleCopyAddress
  };
};